export const enum PayRequestAction {
  REQUESTED = 0,
  APPROVED = 1,
  FINAL_APPROVED = 2,
  DENIED = 3,
  DELETED = 4,
}
